import axios from "axios";
import Config from "../utils/Config";
import API_ENDPOINTS from "../constants/apiEndpoints";

/**
 * Response shape from both /check/phone and /check/email:
 * {
 *   data: {
 *     status_code: 200,
 *     message: "Action Successful",
 *     reason: "...",
 *     data: { exists: boolean },
 *     point_in_time: "..."
 *   }
 * }
 */

class UniquenessCheckApiService {
  constructor() {
    this.baseUrl = Config.API_BASE_URL;
  }

  getHeaders() {
    return {
      headers: { "Content-Type": "application/json" },
    };
  }

  /**
   * Check whether a corporate phone number is already registered.
   * @param {string} corporatePhone - Must be in 233XXXXXXXXX format (12 digits).
   * @returns {Promise<boolean>} Resolves to `true` if the number already exists.
   */
  async checkPhone(corporatePhone) {
    const res = await axios.post(
      `${this.baseUrl}${API_ENDPOINTS.CHECK.PHONE}`,
      { corporate_phone: corporatePhone },
      this.getHeaders()
    );
    return Boolean(res?.data?.data?.data?.exists);
  }

  /**
   * Check whether a corporate email address is already registered.
   * @param {string} corporateEmail - Fully-formed email address.
   * @returns {Promise<boolean>} Resolves to `true` if the email already exists.
   */
  async checkEmail(corporateEmail) {
    const res = await axios.post(
      `${this.baseUrl}${API_ENDPOINTS.CHECK.EMAIL}`,
      { corporate_email: corporateEmail },
      this.getHeaders()
    );
    return Boolean(res?.data?.data?.data?.exists);
  }
}

const uniquenessCheckApiService = new UniquenessCheckApiService();
export default uniquenessCheckApiService;
